"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InsuranceModelState = /** @class */ (function () {
    function InsuranceModelState() {
        this.showInsuranceModal = true;
    }
    return InsuranceModelState;
}());
exports.default = InsuranceModelState;
//# sourceMappingURL=InsuranceModelState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/InsuranceModel/InsuranceModelState.js
// module id = 2254
// module chunks = 8